"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _constant2 = require("./constant");
var _default = {
  PropTypes: {
    currency: _propTypes.string,
    translation: _propTypes.object,
    isInline: _propTypes.bool,
    alignment: (0, _propTypes.oneOf)(_constant2.ALIGNMENT),
    discountInfo: (0, _propTypes.shape)({
      strikethroughPrice: _propTypes.number,
      showCurrency: _propTypes.bool,
      promoLabel: _propTypes.number,
      percentageOff: _propTypes.number
    }),
    theme: _propTypes.object,
    accessible: _propTypes.bool
  },
  DefaultProps: {
    currency: 'MYR',
    isInline: true,
    alignment: 'center',
    translation: {},
    discountInfo: {},
    theme: _constant.DEFAULT_THEME,
    accessible: true
  }
};
exports.default = _default;